/**
 * @Description 导出axios拦截器方法
 * @author 滕威
 * @time 2021-06-15
 */
import axios from "axios";
import qs from "qs";
import Router from "../router/router.js";
import { message } from "../utils/resetMessage";

const service = axios.create({
  baseURL: "/brs-server",
  timeout: 15000,
  withCredentials: true,
  paramsSerializer: params =>
    qs.stringify(params, {
      arrayFormat: "repeat"
    })
});
if (window.location.href.indexOf("?") !== -1) {
  // 截取?后面的参数
  let url = window.location.href.split("?")[1];
  // 获取分割的数组
  let strList = url.split("=");
  // 获取token段落
  let token = null;
  if (strList[0] === "token") {
    token = strList[1];
    sessionStorage.setItem("ebd_token", token);
  }
  // 获取projectName段落
  // let project = strList[1];
  // 获取token
  // const ebd_token = token.split("=")[1];
  // 获取token
  // const projectName = project.split("=")[1];
  // 存储token
  // 存储projectName
  // sessionStorage.setItem("projectName", projectName);
}
service.interceptors.request.use(config => {
  if (sessionStorage.getItem("ebd_token")) {
    config.headers["Authorization"] = sessionStorage.getItem("ebd_token");
  }
  if (
    (config.method === "put" || config.method === "post") &&
    config.headers["Content-Type"] !== "application/json" &&
    config.headers["Content-Type"] !== "multipart/form-data"
  ) {
    config.data = qs.stringify(
      {
        t: Date.parse(new Date()) / 1000,
        ...config.data
      },
      {
        arrayFormat: "repeat"
      }
    );
    // config.data = qs.stringify(config.data, { arrayFormat: "repeat" });
  }
  // 时间戳
  if (config.method === "get") {
    config.params = {
      t: Date.parse(new Date()) / 1000,
      ...config.params
    };
  }
  return config;
}),
  error => {
    Promise.reject(error);
  };

service.interceptors.response.use(
  response => {
    // 401未登录, 301非法访问, 404  都跳到登陆页
    return response;
  },
  error => {
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          if (error.response.data && !error.response.result) {
            message.error(error.response.data.msg);
            // Router.push({
            //   path: "/"
            // });
          }
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default service;
